/**
 * Created by robert.lavoie on 8/7/17.
 */
import {
  Image
} from './';

export enum LogoPosition {
  HEADER = 'logo-header',
  HEADER_AND_INTRO = 'logo-header-and-intro',
  INTRO = 'logo-intro',
};

export interface Theme {
  buttonColor?: string;
  color: string;
  footerBackgroundColor?: string;
  footerColor?: string;
  footerFont?: string;
  font: string;
  headerBackgroundColor?: string;
  headerColor?: string;
  headerFont?: string;
  logo?: Image;
  logoPosition?: LogoPosition;
};
